module.exports = __webpack_public_path__ + "img/cash-paperwork.1607d64b.jpg";